import { api } from '../../lib/api';
import type { GeocodeAutocompleteResponse } from '@pms/shared';

/**
 * GET /v1/public/geocode/autocomplete — as-you-type place suggestions (TASK-146).
 * The storefront api client is already scoped to `/v1/public`, so the path is
 * just `/geocode/autocomplete`. The route is @Public — no token required.
 */
export async function geocodeAutocomplete(
  q: string,
  limit = 6,
  signal?: AbortSignal,
): Promise<GeocodeAutocompleteResponse> {
  const { data } = await api.get<GeocodeAutocompleteResponse>('/geocode/autocomplete', {
    params: { q, limit },
    ...(signal ? { signal } : {}),
  });
  return data;
}
